import { useState, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import useEvent from '../hooks/useEvent';
import FormEvent from '../components/ui/FormEvent';

export default function FormEventMovement(_route) {
    const { animals, locations, events } = useApp();
    if (typeof locations == 'undefined' || locations === null) {
        return (
            <div class="text-center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading locations...</span>
                </div>
            </div>
        );
    }
    const [message, setMessage] = useState("");
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const addToast = useToaster();
    const msgList = [];
    const notWeanedChilds = [];
    const { getEventInfo, saveEvent } = useEvent();
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    const selectedAnimals = eventInfo.selectedAnimals;
    eventInfo.event?.locationId && (eventInfo.locationId = eventInfo.event.locationId);
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    // Move followed mothers with their childs automaticaly
    if (eventInfo.isCreateEvent) {
        selectedAnimals.map(animal => {
            // Do not move a non weaned animal
            if (animal.weaned === false) {
                msgList.push(animal.name + ' n\'est pas sevré veuillez le déplacer avec sa mère en saisissant simplement le déplacement de sa mère');
                setSubmitButtonDisabled(true);
            }
            if (animal.followed && animal.followed > 0) {
                const notWeanedChildsName = [];
                animal.childrenId.map(childId => {
                    const cid = childId.replace('/api/animals/', '');
                    const child = animals.find(a => a.id == cid);
                    // Move only non weaned childs that are not exited
                    if (child && child.weaned === false && child.exited === false) {
                        notWeanedChildsName.push(child.name);
                        notWeanedChilds.push({ id: child.id });
                    }
                })
                msgList.push(animal.name + ' est suitée, ses enfants non sevrés (' + notWeanedChildsName.join(', ') + ') vont être déplacés automatiquement');
            }
        });
        if (msgList.length > 0) setMessage('Attention ! ' + msgList.join(', '));
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formAnimal = {
            location: "/api/locations/" + fields.locationId.value,
        }
        const formEvent = {
            date: fields.date.value,
            notes: fields.notes.value,
            type: 1,
            ...formAnimal
        }
        setSubmitButtonDisabled(true);
        // move all non weaned childs if exists
        if (notWeanedChilds.length > 0) {
            saveEvent(notWeanedChilds, formEvent, formAnimal, false, false).then((responses) => {
                responses.map(response => {
                    addToast(response.type, response.message);
                })
            });
        }
        // save animal and event
        saveEvent(selectedAnimals, formEvent, formAnimal, _route, true).then((responses) => {
            let error = 0;
            responses.map(response => {
                addToast(response.type, response.message);
                if (response.type != 'success') error++;
            })
            setSubmitButtonDisabled(false)
            if (error == 0) {
                history.go(-1);
            }
        });
    }

    return (
        <FormEvent title="Mouvement"
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message={message}
            submitButtonDisabled={submitButtonDisabled}
            setEventInfo={setEventInfo}>
            <div class="form-floating mb-3">
                <select class="form-select" id="locationId" name="locationId" value={eventInfo.locationId}>
                    <option value="">- Choisissez -</option>
                    {
                        locations.map((location) => {
                            return (
                                <option key={location.id} value={location.id}>{location.fullName}</option>
                            )
                        })
                    }
                </select>
                <label class="form-label" for="location">Terrain de destination</label>
            </div>
        </FormEvent>
    );
}